import React from "react";

// components

import CardTable from "components/Tables/CardTable.js";

export default function Farmers() {
    return (
        <>
            <div className="flex flex-wrap mt-4">
                <div className="w-full mb-12 px-4">
                    <CardTable
                        color="light"
                        heading="Farmers"
                        route="/admin/farmers/create"
                        columns={[
                            { label: "Farmer Name", key: "name", render: (value) => <b>{value}</b> },
                            { label: "Phone", key: "phone", render: (value) => <span>{value}</span> },
                            { label: "Address", key: "address", render: (value) => <span>{value}</span> },
                        ]}
                        data={[
                            {
                                name: "John Doe",
                                phone: "+1234567890",
                                address: "123 Farm Lane, Green Valley, Country",
                            },
                            {
                                name: "Jane Smith",
                                phone: "+0987654321",
                                address: "456 Orchard Rd, Blue Ridge, Country",
                            },
                            {
                                name: "Mohamed Ali",
                                phone: "+1122334455",
                                address: "789 Meadow Street, Yellow Fields, Country",
                            },
                            {
                                name: "Emma Williams",
                                phone: "+1212121212",
                                address: "101 Agriculture Blvd, Red Hills, Country",
                            },
                            {
                                name: "Liam Johnson",
                                phone: "+1222333444",
                                address: "202 Plant Rd, White Plains, Country",
                            },
                            {
                                name: "Olivia Brown",
                                phone: "+1333444555",
                                address: "303 Green Acres, Green Valley, Country",
                            },
                        ]}
                    />
                </div>
            </div>
        </>
    );
}